import { SKILLS } from "@/data/content";
import { useReveal } from "@/hooks/useReveal";

export default function Skills() {
  const ref = useReveal();
  return (
    <section id="skills" ref={ref} data-testid="skills-section" className="relative py-28 sm:py-36 bg-[var(--bg-soft)] border-y border-[var(--line)]">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="mb-14 reveal">
          <span className="label">Toolkit</span>
          <h2 className="display mt-5 text-[2.25rem] sm:text-[3.25rem] max-w-2xl text-[var(--ink)]">
            The stack behind <span className="serif-italic">the work.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {SKILLS.map((s) => (
            <div key={s.group} data-testid={`skill-group-${s.group}`} className="reveal border-t border-[var(--line-strong)] pt-6">
              <h3 className="label !text-[var(--accent)] mb-5">{s.group}</h3>
              <ul className="space-y-3">
                {s.items.map((it) => (
                  <li key={it} className="text-sm text-[var(--ink)] leading-snug flex items-start gap-2.5">
                    <span className="mt-2 h-1 w-1 rounded-full bg-[var(--ink-faint)] shrink-0" />
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
